<template>
  <div>
    <span class="text-g3">
      {{ $e("Status du drone") }} :
    </span>
    {{ parachute_fence_status }}
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    parachute_fence_status() {
      let status = this.config?.parachute?.status?.fence_status != undefined
        ? this.config.parachute.status.fence_status
        : -1;

      if (status == 3) {
        return this.$e("Hors de la zone");
      }
      else if (status == 2) {
        return this.$e("Dans la zone warning");
      }
      else if (status == 1) {
        return this.$e("Dans la zone");
      }
      else if (status == 0) {
        return this.$e("Position inconnue");
      }
      else {
        return this.$e("Inconnu");
      }
    },
  },
};
</script>
